<template>
  <v-row>
    <v-col cols="12" class="pt-5 mt-5">
      <img src="@/assets/of-logo.png" alt="Outfox AI" width="350px" class="img-rounded">
    </v-col>

    <v-col cols="12">
      <div class="text-center display-1 grey--text text--darken-2">
        You're ready to Outfox!
      </div>
    </v-col>
    <v-col cols="12">
      <div class="text-center">
        <v-btn
          color="primary"
          @click="gettingStarted"
        >
          Let's go
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'GettingStartedFinal',
    methods: {
      gettingStarted () {
        this.$router.push('/setup-checklist')
      }
    }
  }
</script>

